// Old relive rows (label + continue-prompt echo) are not conversation: the stream drops them on load.
// Copied from server session-relive.ts and iOS AgentStreamReducer.swift (the UI cannot import them).
const LEGACY_LABEL = "Restarted — continuing where it left off";
// Sentences match ANYWHERE (an old echo can sit behind memory context).
const LEGACY_PROMPT_SENTENCES = [
  "Your session was interrupted by a restart (a daemon restart, an app update, or a crash)",
  "Your session was reconnected after a sign-in problem, and your last turn did not run.",
];

/** The continue prompt's echo: synthetic by its fixed wording alone. */
export function isLegacyReliveEcho(text: string): boolean {
  return LEGACY_PROMPT_SENTENCES.some((p) => text.includes(p));
}

/** Set on a label row proven synthetic by the echo behind it; per-row paths hide on it. */
export const RELIVE_HIDDEN = "__reliveHidden";

interface RowLike {
  type?: unknown;
  text?: unknown;
  [RELIVE_HIDDEN]?: unknown;
}

const userText = (row: RowLike): string | undefined =>
  row.type === "user_message" && typeof row.text === "string" ? row.text : undefined;

/** True for an echo row, or a label row a page pass proved to be the old pair's first half. */
export function isHiddenReliveRow(row: RowLike): boolean {
  const text = userText(row);
  return text !== undefined && (isLegacyReliveEcho(text) || row[RELIVE_HIDDEN] === true);
}

/**
 * Flags (never drops: seqs must stay contiguous) a label row only when the NEXT user row is a
 * continue-prompt echo, the old pair. A label a person typed has no echo behind it and stays.
 */
export function markLegacyRelivePairs<T extends RowLike>(items: readonly T[]): T[] {
  const out: T[] = [];
  for (const [i, row] of items.entries()) {
    let flagged = row;
    if (userText(row)?.trim() === LEGACY_LABEL) {
      const next = items.slice(i + 1).find((r) => userText(r) !== undefined);
      if (next && isLegacyReliveEcho(userText(next) ?? ""))
        flagged = { ...row, [RELIVE_HIDDEN]: true };
    }
    out.push(flagged);
  }
  return out;
}
